import { TableCell, TableRow } from "@mui/material";

const RegularCell = (props) => {
  const { config, index, value } = props;

  return (
    <TableCell
      style={{fontWeight:600}}
      align={config.align}
      component={index === 0 ? "th" : ""}
      scope={index === 0 ? "row" : ""}
    >
      {value}
    </TableCell>
  );
};

export default function TotalsRow(props) {
  const { rows, tableConfig, ...rest } = props;
  const getTotal = (config) => {
    if (config.type !== "number") return "";
    return rows.reduce((acc, cv) => (+cv[config.field] || 0) + acc, 0);
  };

  return (
    <TableRow style={{backgroundColor:"#D0D0D0"}} {...rest}>
      {tableConfig.columns
        .filter((tc) => !tc.hidden)
        .map((config, index) => (
          <RegularCell
          config={config}
          index={index}
          key={index}
          style={{ maxWidth: config.width}}
          value={getTotal(config)}
          />
          ))}
          <TableCell  style={{fontWeight:600}} >TOTAL</TableCell>
    </TableRow>
  );
}
